// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"page-first"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 18V6M16.25 17.25L11 12L16.25 6.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PageFirstIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-first',
    ref,
    icon: element,
  },
));

PageFirstIcon.displayName = 'PageFirstIcon';

export default PageFirstIcon;
